export const createuserstatus = `
mutation CreateScreening($input: CreateScreeningInput!) {
  createScreening(input: $input) {
    screening {
      id
      candidateName
      candidateNumber
      position{
        id
      }
      status
      commitmentDate
    }
    success
    error
    message
  }
}
`;

export const updateuserstatus = `
mutation UpdateScreening($input: UpdateScreeningInput!) {
  updateScreening(input: $input) {
    success
    error
    message
    screening {
      id
      candidateName
      candidateNumber
      shortlistFeedback
      status
      commitmentDate
      interviewFeedback
      onboardedFeedback
      onboardDate
      date
      srDate
      createdBy
      createdAt
      updatedAt
      updatedBy
    }
  }
}
`;
export const deleteuserstatus = `mutation DeleteScreening($input: DeleteScreeningInput!) {
  deleteScreening(input: $input) {
    success
    error
    message
  }
}`;

export const getalluserdetailstatus = `
query GetAllScreened(
  $page: Int
  $pageSize: Int
) {
  getAllScreened(
    page: $page
    pageSize: $pageSize
  ) {
    success
    error
    message

    totalCount
    currentPage
    totalPages
    hasNextPage
    hasPreviousPage

    screening {
      id
      candidateName
      candidateNumber
      onboardDate
      shortlistedDate
      interviewDate

      position {
        id
        positionName
      }

      client {
        id
        clientName
      }

      status
      shortlistFeedback
      interviewFeedback
      onboardedFeedback
      date
      createdBy
      createdAt
      updatedAt
      updatedBy
    }
  }
}
`;

export const getallShortlistByHrUser = `query GetAllScreened(
  $hrUserId: ID
  $page: Int
  $pageSize: Int
) {
  getAllScreened(
    hrUserId: $hrUserId
    page: $page
    pageSize: $pageSize
  ) {
    success
    error
    message
 
    totalCount
    currentPage
    totalPages
    hasNextPage
    hasPreviousPage
 
    screening {
      id
      candidateName
      candidateNumber
      onboardDate
      shortlistedDate
      interviewDate
 
      position {
        id
        positionName
      }
 
      client {
        id
        clientName
      }
 
      status
      shortlistFeedback
      interviewFeedback
      onboardedFeedback
      date
      createdBy
      createdAt
      updatedAt
      updatedBy
    }
  }
}
`

export const getallShortlistFilter = `
query ExportFilteredScreenings(
  $filters: ScreeningExportFilterInput
  $page: Int
  $pageSize: Int
) {
  exportFilteredScreenings(
    filters: $filters
    page: $page
    pageSize: $pageSize
  ) {
    success
    message
    error
    downloadUrl
    
    totalCount
    currentPage
    totalPages
    hasNextPage
    hasPreviousPage
    
    screening {
      id
      candidateName
      candidateNumber
      onboardDate
      shortlistedDate
      interviewDate
      joiningDate
      position {
        id
        positionName
      }
      client {
        id
        clientName
      }
      hrUser {
        id
        username
      }
      status
      shortlistFeedback
      interviewFeedback
      onboardedFeedback
      srDate
      date
      createdBy
      createdAt
      updatedAt
      updatedBy
    }
  }
}
`;



// export const searchShortlist = `query SearchScreenedCandidates(
//   $search: String!,
//   $page: Int!,
//   $pageSize: Int!
// ) {
//   searchScreenedCandidates(
//     search: $search,
//     page: $page,
//     pageSize: $pageSize
//   ) {
//     success
//     message
//     totalCount
//     currentPage
//     totalPages
//     hasNextPage
//     hasPreviousPage
 
//     screening {
//       id
//       candidateName
//       candidateNumber
//       onboardDate
//       shortlistedDate
//       interviewDate
 
//       position {
//         id
//         positionName
//       }
 
//       client {
//         id
//         clientName
//       }
 
//       status
//       shortlistFeedback
//       interviewFeedback
//       onboardedFeedback
//       date
//       createdBy
//       createdAt
//       updatedAt
//       updatedBy
//     }
//   }
// }`

export const searchShortlist = `query SearchScreenedCandidates(
  $search: String!
  $hrUserId: ID
  $page: Int
  $pageSize: Int
) {
  searchScreenedCandidates(
    search: $search
    hrUserId: $hrUserId
    page: $page
    pageSize: $pageSize
  ) {
    success
    message
    totalCount
    currentPage
    totalPages
    hasNextPage
    hasPreviousPage
 
    screening {
      id
      candidateName
      candidateNumber
      onboardDate
      shortlistedDate
      interviewDate
 
      position {
        id
        positionName
      }
 
      client {
        id
        clientName
      }
 
      status
      shortlistFeedback
      interviewFeedback
      onboardedFeedback
      date
      createdBy
      createdAt
      updatedAt
      updatedBy
    }
  }
}`